import request from '../kernel/request'

export default {
	goods: {
		list(params) {
			return request.get('goods', params)
		},
		page(params) {
			return request.get('goods/page', params)
		},
		save(data) {
			return request.post(`goods`, data)
		},
		goodsList(data) {
			return request.get(`goods/list`, data)
		},
		update(data) {
			return request.put(`goods`, data)
		},
		load(id) {
			return request.get('goods/' + id)
		},
		delete(id) {
			return request.delete('goods/' + id)
		}
	},
	houseRecord: {
		list(params) {
			return request.get('house/record', params)
		},
		detailList(params) {
			return request.get('house/record/detail', params)
		},
		save(data) {
			return request.post(`house/record`, data)
		},
		update(data) {
			return request.put(`house/record`, data)
		},
		load(id) {
			return request.get('house/record/' + id)
		},
		delete(id) {
			return request.delete('house/record/' + id)
		}
	},
	book: {
		list(params) {
			return request.get('book', params)
		},
		page(params) {
			return request.get('book/page', params)
		},
		clazzPage(params) {
			return request.get('book/clazz/page', params)
		},
		pay(params) {
			return request.get('book/pay', params)
		},
		refund(params) {
			return request.get('book/refund', params)
		},
		save(data) {
			return request.post('book', data)
		},
		update(data) {
			return request.put('book/update', data)
		},
		load(id) {
			return request.get('book/' + id)
		},
		delete(id) {
			return request.delete('book/' + id)
		}
	},
	bookRecord: {
		list(params) {
			return request.get('book/record', params)
		},
		save(data) {
			return request.post('book/record', data)
		},
		insert(data) {
			return request.post('book/record/insert', data)
		},
		update(data) {
			return request.put('book/record/update', data)
		},
		load(id) {
			return request.get('book/record/' + id)
		},
		delete(id) {
			return request.delete('book/record/' + id)
		}
	},
	present: {
		list(params) {
			return request.get('present', params)
		},
		page(params) {
			return request.get('present/page', params)
		},
		save(data) {
			return request.post('present', data)
		},
		update(data) {
			return request.put('present', data)
		},
		load(id) {
			return request.get('present/' + id)
		},
		delete(id) {
			return request.delete('present/' + id)
		}
	},
	presentRecord: {
		list(params) {
			return request.get('present/record', params)
		},
		page(params) {
			return request.get('present/record/page', params)
		},
		save(data) {
			return request.post('present/record/save', data)
		},
		update(data) {
			return request.put('present/record', data)
		},
		load(id) {
			return request.get('present/record/' + id)
		},
		delete(id) {
			return request.delete('present/record/' + id)
		}
	},
	presentApply: {
		list(params) {
			return request.get('present/apply', params)
		},
		page(params) {
			return request.get('present/apply/page', params)
		},
		save(data) {
			return request.post('present/apply/save', data)
		},
		update(data) {
			return request.put('present/apply', data)
		},
		load(id) {
			return request.get('present/apply/' + id)
		},
		delete(id) {
			return request.delete('present/apply/' + id)
		},
		send(id) {
			return request.get('present/apply/send/' + id)
		},
		uploadPicture: `${request.baseURL}/present/apply/uploadPicture`,

	}
}